import type { FaireProductEntity } from "../../entity_types/product";

export const p_hvufrq4drq: FaireProductEntity = {
  token: "p_hvufrq4drq",
  type: "product",
  name: "3 pc Raw Clear quartz point cluster bundle H432",
  brandToken: "b_yrt8x5m6m6",
  brandName: "The 7 Directions",
  imageUrl:
    "https://cdn.faire.com/fastly/0aa2f1094e5eaa8ffa858a6456d1dbc88821ea5368c67aa1dcc7c0098994678d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24ccf01b99176be60cbabb877c85e38bd5c55c356c579ee6b82e35f09e21bac2.jpeg",
    "https://cdn.faire.com/fastly/87e2b8bbcbfb37ba429308a093374b9ef4a595ca1d1209f64396d3c1b512f8fb.jpeg",
    "https://cdn.faire.com/fastly/5a3b4277d0c899e59a322949497ed5671df2baaab2b3c9efa20f14849672c41f.jpeg",
    "https://cdn.faire.com/fastly/557b46989275f1dbdfc74afcff916590526794563ebbaecf1568ada913551815.jpeg",
    "https://cdn.faire.com/fastly/6d4c8d0dd6b56dc262e217b41dac3cfaaaa716dd5203c3982e40993f8c2f7cd4.jpeg",
    "https://cdn.faire.com/fastly/3f63632b4c33f2b1a4676b7591ab36b58f681300a644e88c89502e9bb36b2624.jpeg",
    "https://cdn.faire.com/fastly/282cb4002aab0ec8b6927106f6028419d39c910fef08838899d0d2b689b9fc76.jpeg",
    "https://cdn.faire.com/fastly/ef702f4c74f0e1bf7c262c1ff0058bd3b867fd8f2ec1914d4e2647ed2738b0a0.jpeg",
    "https://cdn.faire.com/fastly/abd099a9742d567ff1a19a717364f777dc715513b1d9801cda2bd50cda6f2a2a.jpeg",
  ],
  priceDollars: 15.24,
  description:
    "3 pc Raw Clear quartz point cluster bundle H432\n\nThis is the exact one you will receive\n\nComes with 1 crystal info card \n\n\n",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:25.495Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
